import { Route, Routes } from "react-router-dom";
import { Header } from "../Header/header";
import Users from "./Users/Users";
import { Customers } from "./Customers/Customers";
import React from "react";
import EventLogs from "./Event Logs/EventLogs";
import { EmployeeLogin } from "../Login/EmployeeLogin";
import { EmployeeOTP } from "../Login/EmployeeOTP";
import { RequireEmployee } from "./RequireEmployee";
import { RequirePWD } from "./RequirePWD";
import { RequireAdmin } from "./RequireAdmin";
import { EmployeeProvider } from "./AdminProvider";
import Billing from "./Billing/Billing";
import Transaction from "./Transaction Logs/Transactions";
import { FSessionTimeout } from "../SessionTimeout";
import { AdminLogout } from "./AdminLogout";
import styles from "./styles/header.module.css";
import { DeleteCustomer } from "./DeleteCustomer/DeleteCustomer";
import { NotFound } from "../Not Found/NotFound";
import Partners from "./Partners/partners";
import EmailTesting from "./Email tests/EmailTesting";
const headerElements = [
  { text: "Customers", link: "/admin/customers" },
  { text: "Eventlogs", link: "/admin/eventlogs" },
  { text: "Billing", link: "/admin/billing" },
  { text: "Transactions Logs", link: "/admin/transactions" },
  { text: "Users", link: "/admin/users" },
  { text: "Delete Customers", link: "/admin/customers/delete" },
  { text: "Partners", link: "/admin/partners" },
  { text: "Emails", link: "/admin/emails" },
  { text: "Logout", link: "/admin/logout" },
];

export function AdminRoutes() {
  return (
    <EmployeeProvider>
      <Routes>
        <Route
          path="/admin/login"
          element={
            <>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                  <Header elements={headerElements} />
                </div>
              <EmployeeLogin />
            </>
          }
        ></Route>
        <Route
          path="/admin/login/OTP"
          element={
            <RequirePWD>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div style={{ position: "relative" }}>
              <div className={styles.header_container}>
                <Header />
              </div>
              </div>
              <EmployeeOTP />
            </RequirePWD>
          }
        ></Route>
        <Route
          path="/admin/customers/delete"
          element={
            <RequireEmployee>
              <RequireAdmin>
                <FSessionTimeout onIdlePath={"/admin/logout"} />
                <div className={styles.header_container}>
                  <Header elements={headerElements} />
                </div>
                <DeleteCustomer />
              </RequireAdmin>
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/users"
          element={
            <RequireEmployee>
              <RequireAdmin>
                <FSessionTimeout onIdlePath={"/admin/logout"} />
                <div className={styles.header_container}>
                  <Header elements={headerElements} />
                </div>
                <Users />
              </RequireAdmin>
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/eventlogs"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <EventLogs />
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/partners"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <Partners />
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/emails"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <EmailTesting />
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/billing"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <Billing />
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/transactions"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <Transaction />
            </RequireEmployee>
          }
        ></Route>
        <Route
          path="/admin/customers"
          element={
            <RequireEmployee>
              <FSessionTimeout onIdlePath={"/admin/logout"} />
              <div className={styles.header_container}>
                <Header elements={headerElements} />
              </div>
              <Customers />
            </RequireEmployee>
          }
        ></Route>
        <Route path="/admin/logout" element={<AdminLogout />}></Route>
      </Routes>
    </EmployeeProvider>
  );
}

export const AdminRoutesv1 = [
  <Route
    path="/admin/login"
    element={
      <>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
            <Header />
          </div>
        <EmployeeLogin />
      </>
    }
  ></Route>,
  <Route
    path="/admin/login/OTP"
    element={
      <RequirePWD>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
            <Header/>
          </div>
        <EmployeeOTP />
      </RequirePWD>
    }
  ></Route>,
  <Route
    path="/admin/customers/delete"
    element={
      <RequireEmployee>
        <RequireAdmin>
          <FSessionTimeout onIdlePath={"/admin/logout"} />
          <div className={styles.header_container}>
            <Header elements={headerElements} />
          </div>
          <DeleteCustomer />
        </RequireAdmin>
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/users"
    element={
      <RequireEmployee>
        <RequireAdmin>
          <FSessionTimeout onIdlePath={"/admin/logout"} />
          <div className={styles.header_container}>
            <Header elements={headerElements} />
          </div>
          <Users />
        </RequireAdmin>
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/eventlogs"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <EventLogs />
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/emails"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <EmailTesting />
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/partners"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <Partners />
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/billing"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <Billing />
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/transactions"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <Transaction />
      </RequireEmployee>
    }
  ></Route>,
  <Route
    path="/admin/customers"
    element={
      <RequireEmployee>
        <FSessionTimeout onIdlePath={"/admin/logout"} />
        <div className={styles.header_container}>
          <Header elements={headerElements} />
        </div>
        <Customers />
      </RequireEmployee>
    }
  ></Route>,
  <Route path="/admin/logout" element={<AdminLogout />}></Route>,
];
